import axios from 'axios';

const SETTINGS = 'SETTINGS';

export default {
  namespaced: true,
  state: () => ({
    values: {},
  }),
  actions: {
    async fetch ({ commit }) {
      const response = await axios.get('/api/settings');
      commit(SETTINGS, response.data.data);
    },
  },
  mutations: {
    [SETTINGS] (state, values) {
      state.values = values;
    },
  },
};
